// @ts-ignore
import React from "react";

import ImageChecklistSide from "@/patterns/image-checklist-side";

const Boards = () => {
    const title = "Powerful agile boards";
    const listItems = [
        <>
            <strong>Scrum boards:</strong> Scrum boards help agile teams break
            large, complex projects into manageable pieces of work so focused
            teams ship faster.
        </>,
        <>
            <strong>Kanban boards:</strong> Agile and DevOps teams can use
            flexible kanban boards to visualize workflows, limit
            work-in-progress, and maximize efficiency as a team. Templates make
            it easy to get started quickly and customize as you go.
        </>,
        <>
            <strong>Choose your own adventure:</strong> Jira Software is
            flexible enough to mold to your team’s own unique way of working,
            whether it is Scrum, Kanban, or something in between.
        </>
    ];
    const imageSrc =
        "https://wac-cdn-2.atlassian.com/dam/jcr:e966255e-69d5-400f-a45c-dec5442225b1/JSW_Boards.png?cdnVersion=ecc";
    const imageAlt = "Jira boards";

    return (
        <ImageChecklistSide
            title={title}
            listItems={listItems}
            imageSrc={imageSrc}
            imageAlt={imageAlt}
        />
    );
};

export default Boards;
